import { render, staticRenderFns } from "./ProposalHitRate.vue?vue&type=template&id=528fb1b0"
import script from "./ProposalHitRate.vue?vue&type=script&lang=js"
export * from "./ProposalHitRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports